import useShowToaster from "@/_hooks/Toasters/useShowToaster";
import AlertIcon from "@/assets/icons/main/redAlert.svg";

interface IErrorHandler {
  handleError: (error: any, defaultMessage?: string) => void;
}

const useErrorHandler = (): IErrorHandler => {
  const showToaster = useShowToaster();

  const handleError = (error: any, defaultMessage?: string): void => {
    const message: string = defaultMessage || "При отправке запроса произошла ошибка. Пожалуйста, попробуйте снова позже.";

    console.error("Произошла ошибка:", error);
    showToaster({
      message,
      icon: <AlertIcon />,
    });
  };

  return { handleError };
};

export default useErrorHandler;
